import { useEffect, useState } from 'react';

/**
 * Shared wrong-PIN retry/lockout timer logic used by PIN entry components.
 * Restores the countdown/lockout state on mount from localStorage so a
 * refreshed or reopened PIN screen keeps enforcing an in-progress lockout.
 */
export const usePinRetryLockout = () => {
  const [countDown, setCountDown] = useState(0);
  const [seconds, setSeconds] = useState(300);
  const [wrongPinCount, setWrongPinCount] = useState(0);
  const [disabledPinInput, setDisabledPinInput] = useState(false);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  let intervalId;
  let timer;

  const timerCounter = (timerValue = 30) => {
    let timeleft = timerValue;
    timer = setInterval(() => {
      if (timeleft <= 0) {
        clearInterval(timer);
        setDisabledPinInput(false);
        localStorage.setItem('wrongOtpCount', 3);
        setCountDown(0);
      } else {
        if (timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  };

  const fiveMinTimeCounter = () => {
    intervalId = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          setWrongPinCount(4);
          localStorage.setItem('wrongOtpCount', 4);
          setDisabledPinInput(false);
          clearInterval(intervalId);
        }
        return prevSeconds - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    clearInterval(intervalId);
    if (localStorage.getItem('wrongOtpCount') === '2') {
      const currentTime = new Date().getTime();
      const tabClosingTime = localStorage.getItem('pinRetriesTimeCounter');
      if (tabClosingTime) {
        const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
        if (differenceInSeconds < 30) {
          setDisabledPinInput(true);
          timerCounter(30 - parseInt(differenceInSeconds));
        }
      } else {
        setDisabledPinInput(true);
        timerCounter();
      }
    }
    if (localStorage.getItem('wrongOtpCount') === '3') {
      setWrongPinCount(3);
    }
    if (localStorage.getItem('wrongOtpCount') === '4') {
      const currentTime = new Date().getTime();
      const tabClosingTime = localStorage.getItem('pinRetriesTimeCounter');
      if (tabClosingTime) {
        const differenceInSeconds = (currentTime - parseInt(tabClosingTime)) / 1000;
        if (differenceInSeconds < 300) {
          setSeconds(300 - parseInt(differenceInSeconds));
          setDisabledPinInput(true);
          setWrongPinCount(3);
          fiveMinTimeCounter();
        }
      } else {
        setWrongPinCount(3);
        fiveMinTimeCounter();
        setDisabledPinInput(true);
      }
    }
    if (localStorage.getItem('wrongOtpCount') === '4') {
      setWrongPinCount(4);
    }
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    countDown,
    seconds,
    setSeconds,
    wrongPinCount,
    setWrongPinCount,
    disabledPinInput,
    setDisabledPinInput,
    minutes,
    remainingSeconds,
    timerCounter,
    fiveMinTimeCounter,
  };
};
